<div class="pt-5 pb-4 position-relative">

</div>
<div class="container mt-5">

    <div class="row text-center">
        <div class="col-md-12">
            <h3 class="text-center mb-4"  style="color: var(--warna-2)">Your bookings</h3>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <!-- <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div> -->

                   
                    
                    <div *ngIf="bookings">

                       
                            <div class="table-responsive-md">
                                <table id="bookTable" class="table">
                            
                                </table>
                            </div>
              

                        
                    </div>
          

                </div>
           </div>
        </div>
    </div>

  <!-- Modal -->
<div class="modal fade" id="cancelModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true" #cancelModal>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cancelModalLabel">Cancel Reservation</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to cancel this reservation <strong>{{selectedBookingId}}</strong>? <br/> This action cannot be undone.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-danger" (click)="confirmCancellation()">Confirm</button>
        </div>
      </div>
    </div>
  </div> 
</div>



<div *ngIf="isModalVisible" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Cancellation Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
          <div [innerHTML]="ketBatal"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>



<!-- Toast Notification -->
<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
    <div 
      *ngFor="let toast of toasts"
      class="toast show align-items-center text-white border-0" 
      role="alert" 
      aria-live="assertive" 
      aria-atomic="true"
      [ngClass]="{
        'bg-success': toast.type === EventTypes.Success,
        'bg-danger': toast.type === EventTypes.Error,
        'bg-warning': toast.type === EventTypes.Warning,
        'bg-info': toast.type === EventTypes.Info
      }">
      <div class="d-flex">
        <div class="toast-body">
          <strong>{{ toast.title }}</strong>
          <div>{{ toast.message }}</div>
        </div>
        <button type="button" 
                class="btn-close btn-close-white me-2 m-auto" 
                (click)="removeToast(toast)" 
                aria-label="Close">
        </button>
      </div>
    </div>
  </div>

